<template>
  <div>
    <div class="m-navbar" :style="{'backgroundColor':(changeNavStyle?'':'#fff'),
    'boxShadow':(changeNavStyle||(currentPath == '/mobile_product')?'none':'0 0 5px #eee')}">
      <div class="logo">
        <img src="@/assets/image/logo-light.png" v-show="changeNavStyle">
        <img src="@/assets/image/logo.png" v-show="!changeNavStyle">
      </div>
      <div class="nav-btn" @click="showBar()">
        <div class="icon" :style="{'border': (changeNavStyle?'0.27vw solid #fff':'0.27vw solid #000')}"></div>
        <div class="icon"
             :style="{'width':(isShow?'30%':''),'border': (changeNavStyle?'0.27vw solid #fff':'0.27vw solid #000')}"></div>
        <div class="icon" :style="{'border': (changeNavStyle?'0.27vw solid #fff':'0.27vw solid #000')}"></div>
      </div>
    </div>
    <div class="mask" :style="{'right':(isShow?'0px':'-100%')}">
      <div class="mask-left" @click="hideBar()"></div>
      <div class="m-navbar-con">
        <div class="m-navbar-item" @click="toMbHome()">蓝猿之家 <span v-if="currentPath=='/mobile_home'"></span></div>
        <div class="m-navbar-item" @click="toProductCenter()">我的手艺 <span v-if="currentPath=='/mobile_product'"></span></div>
        <div @click="showSvBar()" class="m-navbar-item">擅长技能
          <i class="el-icon-arrow-down" v-if="!svBarState"></i>
          <i class="el-icon-arrow-up" v-if="svBarState"></i>
        </div>
        <div class="secondray-dir" :style="{'height':(svBarState?'144px':'0')}">
          <div class="secondray-dir-item" @click="$router.push({path: '/mobile_service',query: {id: 0}})">小程序定制</div>
          <div class="secondray-dir-item" @click="$router.push({path: '/mobile_service',query: {id: 1}})">网站定制</div>
          <div class="secondray-dir-item" @click="$router.push({path: '/mobile_service',query: {id: 2}})">APP定制</div>
        </div>
        <router-link to="/mobile_about" class="m-navbar-item">
          <div>想对你说 <span v-if="currentPath=='/mobile_about'"></span></div>
        </router-link>
        <div class="m-navbar-item" @click="$router.push('/mobile_contact')">联系我们</div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "navbar",
    data() {
      return {
        isShow: false,
        currentPath: this.$route.path,
        svBarState: false,
        ctBarState: false,
        // changeSvMask:false
        maskState: false,
        scrollTop: 0,
        changeNavStyle: true,
        isRouterAlive: true
      }
    },
    mounted() {
      if (this.currentPath != '/mobile_service' && this.currentPath != '/mobile_product') {
        window.addEventListener('scroll', this.handleScroll, true);
      } else {
        this.changeNavStyle = false
      }
    },
    methods: {
      toAbout() {
        this.$router.replace('/mobile_about')
      },
      toMbHome() {
        this.$router.push('/mobile_home')
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      toProductCenter() {
        this.$router.push('/mobile_product')
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollTop >= 10) {
          this.changeNavStyle = false
        } else {
          this.changeNavStyle = true
        }
      },
      showBar() {
        this.isShow = !this.isShow
      },
      hideBar() {
        this.isShow = false
      },
      showSvBar() {
        this.svBarState = !this.svBarState
        // setTimeout(this.changeSvMask, 1)
        // this.changeSvMask()
      },
      showCtBar() {
        this.ctBarState = !this.ctBarState
      }
    }
  }
</script>

<style scoped>
  .m-navbar-con span {
    display: inline-block;
    width: 1.2vw;
    height: 1.2vw;
    border-radius: 50%;
    border: 1.2px solid #333;
    margin-left: 2vw;
  }

  .m-navbar {
    height: 12vw;
    width: 100%;
    /*background-color: #f5f5f5;*/
    /*border-bottom: 1px solid #333;*/
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    transition: all .5s;
    /*background-color: #fff;*/
    z-index: 6;
  }

  .logo {
    height: 100%;
    display: flex;
    align-items: center;
    /*width: ;*/
  }

  .logo img {
    height: 60%;
  }

  .nav-btn {
    /*background-color: #eee;*/
    height: 100%;
    width: 12vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 3%;
    z-index: 9;
    cursor: pointer;
  }

  .icon {
    width: 40%;
    border: 0.27vw solid #fff;
    margin: 0.5vw 0;
    align-self: flex-end;
    transition: all .5s;
  }

  .mask {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    transition: right .5s;
    z-index: 6;
  }

  .mask-left {
    width: 100vw;
    height: 100vh;
  }

  .m-navbar-con {
    width: 38.4vw;
    height: 100vh;
    box-shadow: -2px 6px 10px rgba(118, 128, 135, 0.3);
    background-color: #fff;
    position: absolute;
    top: 40px;
    right: 0;
    line-height: 14vw;
    /*text-indent: 2em;*/
    z-index: 4;
    /*padding-left: 7vw;*/
    box-sizing: border-box;
    padding-top: 5vw;
  }

  .m-navbar-item {
    height: 14vw;
    font-size: .875em;
    text-indent: 1.8em;
    cursor: pointer;
  }

  .service-bar {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    top: 0;
    /*font-size: 0.875em;*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*flex-direction: column;*/
    /*align-items: center;*/
    z-index: 88;
    /*transition: all .2s;*/
  }

  .back-btn {
    /*width: 20vw;*/
    padding-left: 5vw;
    font-size: .69em;
    height: 8vw;
    padding-top: 4vw;
    /*border-bottom: .8px solid #dbdbdb;*/
    letter-spacing: .1em;
  }

  .back-btn img {
    /*width: 5vw;*/
    height: 3vw;
  }

  .service-bar-item {
    text-align: center;
    color: #888;
    font-size: .875em;
    height: 13.3vw;
    line-height: 13.3vw;
    /*height: 20vw;*/
    /*width: 50vw;*/
    /*line-height: 20vw;*/
    border-bottom: .8px solid #dbdbdb;
  }

  .service-bar-item:first-child {
    border-top: .8px solid #dbdbdb;
  }

  .sv-mask {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    background-color: #fff;
    transition: all 3s;
    z-index: 1;
  }

  .secondray-dir {
    color: #555;
    font-size: .75em;
    line-height: 400%;
    /*border-top: .5px solid #f5f5f5;*/
    /*border-bottom: .5px solid #f5f5f5;*/
    text-indent: 2em;
    height: 0;
    overflow: hidden;
    transition: all .5s;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/navbar.vue